import React from 'react';

export default function LoadingSpinner({ size = 40, text = '' }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px' }}>
      <div style={{
        width: size,
        height: size,
        border: '3px solid var(--bg-tertiary)',
        borderTop: '3px solid var(--accent)',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite'
      }} />
      {text && <p style={{ marginTop: 12, color: 'var(--text-secondary)', fontSize: 14 }}>{text}</p>}
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
